type Tone = 'gray' | 'amber' | 'green'

interface Props {
  tone: Tone
  icon: React.ReactNode
  title: string
  description?: string
}

/**
 * Empty/error/success state block — round colored icon bubble + title + optional
 * description. Used for invalid token, expired profile link, and form-submit
 * success states across the app.
 */
export default function StateMessage({
  tone,
  icon,
  title,
  description,
}: Props) {
  return (
    <div className="state">
      <div className={`status-bubble status-bubble-${tone}`}>{icon}</div>
      <p className="state-title">{title}</p>
      {description && <p className="state-desc">{description}</p>}
    </div>
  )
}
